// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_container__TePkC {
  max-width: 400px;
  margin: 40px auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px #0001;
  padding: 32px 24px;
  text-align: center;
}
.Profile_profileInfo__gG73X {
  margin-top: 24px;
  font-size: 1.1em;
  color: #333;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Profile/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".container {\r\n  max-width: 400px;\r\n  margin: 40px auto;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px #0001;\r\n  padding: 32px 24px;\r\n  text-align: center;\r\n}\r\n.profileInfo {\r\n  margin-top: 24px;\r\n  font-size: 1.1em;\r\n  color: #333;\r\n  text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Profile_container__TePkC`,
	"profileInfo": `Profile_profileInfo__gG73X`
};
export default ___CSS_LOADER_EXPORT___;
